import React, { useEffect, useState } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiMailCheckFill } from "react-icons/ri";
import Loading from "../../images/loading.gif";
import { backendApi } from "../../api/apiService";

export default function Register() {
  const location = useLocation();
  const navigate=useNavigate();
  let orgEmail = location.state.email;
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [email, setEmail] = useState("");
  const [isloading, setIsloading] = useState(false);

  useEffect(() => {
    setEmail(obfuscateEmail(orgEmail));
  }, [orgEmail]);

  const obfuscateEmail = (email) => {
    const [username, domain] = email.split("@");
    const [domainName, domainExtension] = domain.split(".");
    const obfuscatedDomain = `${domainName.slice(0, 1)}----`;
    return `${username}@${obfuscatedDomain}.${domainExtension}`;
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const verifyOtp=()=>{
    const otpCheck = otp.every(digit => digit !== '');
    const combinedOtp = otp.join('');
    if (!otpCheck) {
      toast.warn('Please fill in all OTP digits.', { containerId: "D" });
      return false;
    } 
    setIsloading(true)
    var req = {
      functionName: "verifyOTP",
      emailOTP: combinedOtp,
      candidateId: location.state.candidateId,
      email_id:orgEmail
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success(
            "Account created successfully.Please log in to continue",
            { containerId: "D" }
          );
          setTimeout(()=>{
            navigate("/candidateLogin");
          },2000);

        }else{
          toast.error(
            "Invalid OTP.Please try again",
            { containerId: "D" }
          );
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const resendOTP=()=>{
    var req = {
      functionName: "resendOTP",
      candidateId: location.state.candidateId,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success(
            "OTP sent to your email account!",
            { containerId: "D" }
          );
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsloading(false);
      });
  }

  return (
    <div className="xilliCrm bg-login">
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="main-wraps active col-lg-5 p-3" id="container">
        <div className="row">
          <div class="bg-white p-5 rounded-3 shadow-sm">
            <div>
              <p
                class="text-center text-success"
                style={{ fontSize: "5.5rem" }}
              >
                <RiMailCheckFill fontSize={100} color="#198754" />
              </p>
              <p class="text-center text-center h5 ">Please check your email</p>
              <p class="text-muted text-center">We've sent a code to {email}</p>
              <div class="row pt-4 pb-2">
                {otp.map((digit, index) => (
                  <div className="col-3" key={index}>
                    <input
                      className="otp-letter-input"
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                    />
                  </div>
                ))}
              </div>
              <p class="text-muted text-center">
                Didn't get the code?{" "}
                <a class="text-success cursor-pointer" onClick={resendOTP}>
                  Click to resend.
                </a>
              </p>

              <div class="row pt-5">
                <div class="col-6">
                  <button class="btn btn-outline-secondary w-100">
                    Cancel
                  </button>
                </div>
                <div class="col-6">
                  <button class="btn btn-success w-100" onClick={verifyOtp}>
                    {isloading ? (
                      <img
                        src={Loading}
                        alt="loaderImg"
                        width={20}
                        height={20}
                      />
                    ) : (
                      "Verify"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
